/** テレビ向けデモ専用（日本の天気予報グラフィック風） */

export const tvSkyGradient =
  'linear-gradient(165deg, #b8e6ff 0%, #6ec5f8 28%, #3d9ee8 62%, #2478c8 100%)';

export const tvTextStroke = (stroke = '#0d4a8f') => ({
  textShadow: `
    -1px -1px 0 ${stroke},
    1px -1px 0 ${stroke},
    -1px 1px 0 ${stroke},
    1px 1px 0 ${stroke},
    0 2px 6px rgba(0,0,0,0.2)
  `,
});

/** 単画面プレビュー周辺の方眼用紙背景 */
export const tvGraphPaperBg = {
  backgroundColor: '#f8f8f8',
  backgroundImage: `
    linear-gradient(rgba(0, 0, 0, 0.07) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 0, 0, 0.07) 1px, transparent 1px)
  `,
  backgroundSize: '22px 22px',
};

/** 放送モニター風ベゼル（角丸なし・太枠） */
export const tvBroadcastBezel = {
  padding: '16px',
  bgcolor: '#1c1c1c',
  borderRadius: 0,
  boxShadow:
    '0 12px 40px rgba(0,0,0,0.35), inset 0 0 0 1px #3d3d3d, inset 0 2px 4px rgba(255,255,255,0.08)',
};

export const tvTheme = {
  frame: {
    aspectRatio: '16 / 9',
    borderRadius: 10,
    border: '3px solid rgba(255,255,255,0.85)',
    shadow: '0 6px 24px rgba(13,74,143,0.35)',
  },
  colors: {
    skyGradient: tvSkyGradient,
    panelGlass: 'rgba(255,255,255,0.94)',
    panelBorder: '3px solid #fff',
    labelBar: '#1565b8',
    headerBar: '#dceefb',
    gridLine: '#ffffff',
    titleOrange: '#ff6b00',
    titleOrangeStroke: '#fff',
    accentBlue: '#0d47a1',
    saturday: '#1565c0',
    sunday: '#c62828',
    tickerBar: 'linear-gradient(90deg, #1565b8, #1976d2)',
    gold: '#ffb300',
    textOnSky: '#ffffff',
    textDark: '#0d3d6e',
    textMuted: '#4a6f8f',
  },
  /** 一覧(2x2)でも読めるサイズ / 単画面はさらに大きく */
  heatmap: {
    compact: {
      labelW: 64,
      headerH: 28,
      cellH: 36,
      cellMinW: 34,
      valueFont: 16,
      labelFont: 13,
      headerFont: 11,
    },
    full: {
      labelW: 100,
      headerH: 40,
      cellH: 64,
      cellMinW: 48,
      valueFont: 34,
      labelFont: 21,
      headerFont: 17,
    },
    /** 駅前パネル：色尺度は同じ、文字だけ大きく */
    station: {
      labelW: 72,
      headerH: 36,
      cellH: 44,
      cellMinW: 40,
      valueFont: 20,
      labelFont: 16,
      headerFont: 14,
    },
    stationFull: {
      labelW: 96,
      headerH: 48,
      cellH: 76,
      cellMinW: 52,
      valueFont: 40,
      labelFont: 24,
      headerFont: 22,
    },
    /** 背景オーバーレイ用（色尺度は同じ・コンパクトに収める） */
    stationOverlay: {
      labelW: 48,
      headerH: 24,
      cellH: 28,
      cellMinW: 28,
      valueFont: 15,
      labelFont: 12,
      headerFont: 11,
    },
    stationOverlayFull: {
      labelW: 68,
      headerH: 34,
      cellH: 46,
      cellMinW: 44,
      valueFont: 28,
      labelFont: 17,
      headerFont: 15,
    },
    /** 画面4・5：週間7行（読みやすさ優先） */
    stationOverlayWeek: {
      labelW: 56,
      headerH: 30,
      cellH: 36,
      cellMinW: 38,
      valueFont: 18,
      labelFont: 14,
      headerFont: 13,
    },
    /** 画面6：4地点×7日（正式な地点名） */
    pastWeekOverview: {
      labelW: 88,
      headerH: 28,
      cellH: 34,
      cellMinW: 34,
      valueFont: 16,
      labelFont: 11,
      headerFont: 12,
    },
  },
  typography: {
    channel: { fontSize: 'clamp(1rem, 1.6vw, 1.4rem)', fontWeight: 700 },
    heroTitle: { fontSize: 'clamp(2.75rem, 7vw, 4.25rem)', fontWeight: 900 },
    heroSubtitle: { fontSize: 'clamp(1.35rem, 3vw, 2.25rem)', fontWeight: 700 },
    heroDate: { fontSize: 'clamp(1.5rem, 3.5vw, 2.6rem)', fontWeight: 700 },
    panelTitle: { fontSize: 'clamp(1.15rem, 2.2vw, 1.7rem)', fontWeight: 800 },
    peakBadge: { fontSize: 'clamp(1rem, 1.85vw, 1.4rem)', fontWeight: 800 },
    insightTitle: { fontSize: 'clamp(1.05rem, 1.8vw, 1.45rem)', fontWeight: 800 },
    insightBody: { fontSize: 'clamp(0.95rem, 1.55vw, 1.2rem)', fontWeight: 700 },
  },
};

export const tvColLabelColor = (label) => {
  if (label === '今日' || label === '明日' || String(label).startsWith('前年')) {
    return tvTheme.colors.accentBlue;
  }
  if (label.startsWith('土')) return tvTheme.colors.saturday;
  if (label.startsWith('日')) return tvTheme.colors.sunday;
  return tvTheme.colors.textDark;
};

export default tvTheme;
